/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/DataPointActionsAPI',
	'underscore'
], (APIFactory, DataPointActionsAPI, _) => {

	class DataPointActions {

		constructor() {
			this.api = APIFactory.createAPI(this, [DataPointActionsAPI]);
			this.providers = {};
		}

		registerProvider(name, provider) {
			this.providers[name] = provider;
		}

		getDataPointActionList(selections, options) {
			let actions = [];
			for (let actionName in this.providers) {
				const provider = this.providers[actionName];
				if (provider.getDataPointActionList) {
					let dataPointAction = null;
					try {
						dataPointAction = provider.getDataPointActionList(selections, options);
					} catch(e) {
						console.log(e);
					}
					if (!_.isEmpty(dataPointAction)) {
						actions.push(...dataPointAction);
					}
				}
			}

			return actions;
		}

		getAPI(){
			return this.api;
		}
	}

	return DataPointActions;
});
